import { render } from "./AddInvest.vue?vue&type=template&id=0da423ec&scoped=true"
import script from "./AddInvest.vue?vue&type=script&lang=js"
export * from "./AddInvest.vue?vue&type=script&lang=js"

import "./AddInvest.vue?vue&type=style&index=0&id=0da423ec&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da423ec"]])

export default __exports__